module.exports = __webpack_public_path__ + "img/zeelab.a755b0c5.png";